import { ComplexValue } from 'app/types-shared';
import { ImportSetItem, ImportSetItemValidation } from './types-store';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'IMPORT_SET_ADMIN_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'IMPORT_SET_ADMIN_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'IMPORT_SET_ADMIN_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:REQUEST_IMPORT_SET',
  RECEIVE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:RECEIVE_IMPORT_SET',
  FAIL_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:FAIL_IMPORT_SET',

  REQUEST_DELETE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:REQUEST_DELETE_IMPORT_SET',
  RECEIVE_DELETE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:RECEIVE_DELETE_IMPORT_SET',
  FAIL_DELETE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:FAIL_DELETE_IMPORT_SET',

  REQUEST_SAVE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:REQUEST_SAVE_IMPORT_SET',
  RECEIVE_SAVE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:RECEIVE_SAVE_IMPORT_SET',
  FAIL_SAVE_IMPORT_SET: 'IMPORT_SET_ADMIN_FORM:FAIL_SAVE_IMPORT_SET',

  UPDATE_ITEM: 'IMPORT_SET_ADMIN_FORM:UPDATE_ITEM',

  CHANGE_LANGUAGE: 'IMPORT_SET_ADMIN_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'IMPORT_SET_ADMIN_FORM:COPY_LANGUAGE_TO_ALL',

  CLEAR_FORM: 'IMPORT_SET_ADMIN_FORM:CLEAR_FORM',

  UPDATE_VALIDATION: 'IMPORT_SET_ADMIN_FORM:UPDATE_VALIDATION',
  UPDATE_VALIDATION_BY_KEY: 'IMPORT_SET_ADMIN_FORM:UPDATE_VALIDATION_BY_KEY',
  RESET_VALIDATION: 'IMPORT_SET_ADMIN_FORM:RESET_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestImportSet {
  public type: string = ACTION.REQUEST_IMPORT_SET;
}

export class ReceiveImportSet {
  public type: string = ACTION.RECEIVE_IMPORT_SET;
  constructor(
    public item: ImportSetItem
  ) { }
}

export class FailImportSet {
  public type: string = ACTION.FAIL_IMPORT_SET;
}

export class RequestDeleteImportSet {
  public type: string = ACTION.REQUEST_DELETE_IMPORT_SET;
}

export class ReceiveDeleteImportSet {
  public type: string = ACTION.RECEIVE_DELETE_IMPORT_SET;
}

export class FailDeleteImportSet {
  public type: string = ACTION.FAIL_DELETE_IMPORT_SET;
}

export class RequestSaveImportSet {
  public type: string = ACTION.REQUEST_SAVE_IMPORT_SET;
}

export class ReceiveSaveImportSet {
  public type: string = ACTION.RECEIVE_SAVE_IMPORT_SET;
}

export class FailSaveImportSet {
  public type: string = ACTION.FAIL_SAVE_IMPORT_SET;
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<ImportSetItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: ImportSetItemValidation) { }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: string) {
  }
}
